import { getDatabase } from 'firebase/database';

import { app } from '.';

export const RealtimeDatabase = getDatabase(app);
